import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            剧集分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按国家和类型快速浏览，找到你最感兴趣的剧集频道
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex flex-col items-center text-center p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-300/40 transition-all cursor-pointer"
            >
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-md bg-primary-100 mb-3">
                <i className={`${item.icon} text-lg md:text-xl text-primary-500`}></i>
              </span>
              <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                {item.name}
              </h3>
              <p className="text-xs text-foreground-500 mb-1.5 hidden sm:block">{item.description}</p>
              <span className="text-xs font-semibold text-primary-500 bg-primary-50 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                {item.count}
              </span>
            </a>
          ))}
          <div className="col-span-2 sm:col-span-3 lg:col-span-1 flex items-center justify-center">
            <a
              href="#index"
              className="flex flex-col items-center justify-center w-full h-full min-h-[120px] p-4 bg-background-50 rounded-lg border border-dashed border-background-300/60 hover:border-primary-300/40 transition-all cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center mb-2">
                <i className="ri-arrow-right-circle-line text-2xl text-foreground-400"></i>
              </span>
              <span className="text-sm font-medium text-foreground-500 whitespace-nowrap">更多分类</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}